import React, { Component } from "react";
import * as XLSX from 'xlsx';

//Import Breadcrumb
import { Row, Col, Card, CardBody, CardTitle, Button, FormGroup, Label } from "reactstrap"
//Constants
import { API_WEB_URLS } from "../../constants/constAPI";
//Store
import { compose } from "recompose";
import { container } from "../../store/Containers/cntCommon";
import {
  Fn_FillListData,
  togglemodal,
  toggleDeleteConfirm,
  toggleDeleteSuccess,
  Fn_DeleteData,
  Fn_GetReport,
} from "../../store/functions";
import "../Masters/datatables.scss"
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, {
  PaginationProvider, PaginationListStandalone,
  SizePerPageDropdownStandalone
} from 'react-bootstrap-table2-paginator';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

class GstReport extends Component {
  constructor(props) {
    super(props);
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const fromDate = new Date(currentYear, 3, 1); // April 1st of current year
    const toDate = new Date(currentYear + 1, 2, 31); // March 31st of next year

    this.state = {
      modal: false,
      selectedFormData: {},
      gridData: [],
      confirm_alert: false,
      success_dlg: false,
      dynamic_title: "",
      dynamic_description: "",
      page: 1,
      sizePerPage: 10,
      productData: [],
      fromDate: fromDate,
      toDate: toDate
    };
    this.obj = this;
    this.breadCrumbTitle = "Masters";
    this.breadCrumbItem = "Ledger";
    this.modalTitle = "Company Details";
    this.rtPage_Add = "AddLedger";
    this.rtPage_Edit = "EditLedger";
    this.API_URL = API_WEB_URLS.MASTER + "/0/token/LedgerMaster";

    //Event Binding
    this.btnAdd_onClick = this.btnAdd_onClick.bind(this);
    this.btnEdit_onClick = this.btnEdit_onClick.bind(this);
    this.btnDelete_onClick = this.btnDelete_onClick.bind(this);
    this.handleFromDateChange = this.handleFromDateChange.bind(this);
    this.handleToDateChange = this.handleToDateChange.bind(this);
    this.exportToExcel = this.exportToExcel.bind(this);
    this.printReport = this.printReport.bind(this);
  }

  componentDidMount() {
    const obj = JSON.parse( sessionStorage.getItem("authUser"));
    Fn_FillListData(this.obj, "Fillarray", this.API_URL + "/Id/0");
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.Fillarray !== this.state.Fillarray) {
      const options = this.state.Fillarray.map(item => ({
        value: item.Id,
        label: item.Name
      }));

      console.log(options);
      this.setState({ ledgerOptions: options });
    }
  }

  handleFromDateChange(date) {
    this.setState({ fromDate: date });
  }

  handleToDateChange(date) {
    this.setState({ toDate: date });
  }

  handleSubmit = () => {
    const { fromDate, toDate } = this.state;
    console.log('Selected Values:', {
      fromDate: fromDate,
      toDate: toDate
    });

    // Format dates for SQL Server (YYYY-MM-DD)
    const formatDate = (date) => {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    
    let vformData = new FormData();
    vformData.append("FromDate", formatDate(fromDate));
    vformData.append("ToDate", formatDate(toDate));
    Fn_GetReport(this.obj, {  arguList: {id: 0, formData: vformData } }, "GSTReport/0/token", "gridData", true );
  }

  btnAdd_onClick(event, values) {
    this.props.history.push(`${this.rtPage_Add}`);
  }
  btnEdit_onClick(Id) {
    this.props.history.push(`${this.rtPage_Edit}/${Id}`, {});
  }
  btnDelete_onClick(formData) {
    Fn_DeleteData(this.obj, formData.Id, this.API_URL, this.API_URL + "/Id/0");
  }

  exportToExcel = () => {
    const obj = JSON.parse( sessionStorage.getItem('authUser'))
    console.log(obj)
    if (this.state.gridData && this.state.gridData.length > 0) {
      // Prepare headers
      const headers = [
        'Party Name',
        'Total Bills',
        'Gross Amount',
        'Tax Amount',
        'Net Amount'
      ];

      // Prepare data
      const data = this.state.gridData.map(item => [
        item.Name,
        item.TotalBill,
        Number(item.GrossAmount).toFixed(2),
        Number(item.TaxationAmount).toFixed(2),
        Number(item.NetAmount).toFixed(2)
      ]);

      // Combine headers and data
      const excelData = [headers, ...data];

      // Create worksheet
      const ws = XLSX.utils.aoa_to_sheet(excelData);

      // Set column widths
      const wscols = [
        { wch: 30 }, // Party Name
        { wch: 15 }, // Total Bills
        { wch: 15 }, // Gross Amount
        { wch: 15 }, // Tax Amount
        { wch: 15 }  // Net Amount
      ];
      ws['!cols'] = wscols;

      // Create workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Invoice Report');

      // Save file
      XLSX.writeFile(wb, 'InvoiceReport.xlsx');
    }
  }

  printReport = () => {
    if (this.state.gridData && this.state.gridData.length > 0) {
      const printWindow = window.open('', '_blank');
      const obj = JSON.parse( sessionStorage.getItem('authUser'));
      
      // Create the print content
      const printContent = `
        <html>
          <head>
            <title>GST Report</title>
            <style>
              body { font-family: Arial, sans-serif; font-size: 11px; }
              table { 
                width: 100%; 
                border-collapse: collapse; 
                margin: 20px 0; 
                min-height: 65vh;
                border: 1px solid #dee2e6;
              }
              th, td { 
                border: 1px solid #dee2e6; 
                padding: 8px; 
                font-size: 10px; 
                white-space: nowrap;
              }
              th { 
                background-color: #f8f9fa;
                font-weight: 600;
                vertical-align: middle;
              }
              th:first-child, td:first-child {
                text-align: left;
              }
              th:not(:first-child), td:not(:first-child) {
                text-align: right;
              }
              .header { text-align: center; margin-bottom: 20px; }
              .date-range { margin-bottom: 20px; }
              .text-right { text-align: right; }
              tr:last-child {
                font-weight: bold;
                background-color: #f8f9fa;
              }
              @media print {
                .no-print { display: none; }
                body { font-size: 11px; padding: 0 10mm; }
                th, td { font-size: 10px; padding: 6px; }
                table { page-break-inside: auto; min-height: 75vh; }
                tr { page-break-inside: avoid; page-break-after: auto; }
                thead { display: table-header-group; }
                tfoot { display: table-footer-group; }
              }
            </style>
          </head>
          <body>
            <div class="header">
              <h2>GST Report</h2>
              <div class="date-range">
                <strong>${obj.FirmName}</strong><br>
                From: ${this.state.fromDate.toLocaleDateString('en-GB', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric'
                }).split('/').join('-')} To: ${this.state.toDate.toLocaleDateString('en-GB', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric'
                }).split('/').join('-')}
              </div>
            </div>
            <table>
              <thead>
                <tr>
                  <th>Party Name</th>
                  <th style="text-align: right">Total Bills</th>
                  <th style="text-align: right">Gross Amount</th>
                  <th style="text-align: right">Tax Amount</th>
                  <th style="text-align: right">Net Amount</th>
                </tr>
              </thead>
              <tbody>
                ${this.state.gridData.map(item => `
                  <tr>
                    <td>${item.Name}</td>
                    <td class="text-right">${item.TotalBill}</td>
                    <td class="text-right">${Number(item.GrossAmount).toFixed(2)}</td>
                    <td class="text-right">${Number(item.TaxationAmount).toFixed(2)}</td>
                    <td class="text-right">${Number(item.NetAmount).toFixed(2)}</td>
                  </tr>
                `).join('')}
                ${this.state.gridData.length > 0 ? `
                  <tr style="font-weight: bold; background-color: #f8f9fa;">
                    <td>Total</td>
                    <td class="text-right">${this.state.gridData.reduce((sum, item) => sum + Number(item.TotalBill), 0)}</td>
                    <td class="text-right">${Number(this.state.gridData.reduce((sum, item) => sum + Number(item.GrossAmount), 0)).toFixed(2)}</td>
                    <td class="text-right">${Number(this.state.gridData.reduce((sum, item) => sum + Number(item.TaxationAmount), 0)).toFixed(2)}</td>
                    <td class="text-right">${Number(this.state.gridData.reduce((sum, item) => sum + Number(item.NetAmount), 0)).toFixed(2)}</td>
                  </tr>
                ` : ''}
              </tbody>
            </table>
            <div class="no-print" style="text-align: center; margin-top: 20px;">
              <button onclick="window.print()">Print Report</button>
            </div>
          </body>
        </html>
      `;

      printWindow.document.write(printContent);
      printWindow.document.close();
    }
  }

  render() {
    const columns = [{
      dataField: 'Name',
      text: 'Party Name',
      sort: true,
      searchable: true,
      style: {
        textAlign: 'left'
      },
      headerStyle: {
        textAlign: 'left',
        borderLeft: '1px solid #dee2e6',
        borderRight: '1px solid #dee2e6',
        verticalAlign: 'middle'
      }
    }, {
      dataField: 'TotalBill',
      text: 'Total Bills',
      sort: true,
      searchable: true,
      style: {
        textAlign: 'right',
        borderLeft: '1px solid #dee2e6',
        borderRight: '1px solid #dee2e6'
      },
      headerStyle: {
        textAlign: 'right',
        borderLeft: '1px solid #dee2e6',
        borderRight: '1px solid #dee2e6',
        verticalAlign: 'middle'
      }
    }, {
      dataField: 'GrossAmount',
      text: 'Gross Amount',
      sort: true,
      searchable: true,
      style: {
        textAlign: 'right',
        borderLeft: '1px solid #dee2e6',
        borderRight: '1px solid #dee2e6'
      },
      headerStyle: {
        textAlign: 'right',
        borderLeft: '1px solid #dee2e6',
        borderRight: '1px solid #dee2e6',
        verticalAlign: 'middle'
      },
      formatter: (cell) => Number(cell).toFixed(2)
    }, {
      dataField: 'TaxationAmount',
      text: 'Tax Amount',
      sort: true,
      searchable: true,
      style: {
        textAlign: 'right',
        borderLeft: '1px solid #dee2e6',
        borderRight: '1px solid #dee2e6'
      },
      headerStyle: {
        textAlign: 'right',
        borderLeft: '1px solid #dee2e6',
        borderRight: '1px solid #dee2e6',
        verticalAlign: 'middle'
      },
      formatter: (cell) => Number(cell).toFixed(2)
    }, {
      dataField: 'NetAmount',
      text: 'Net Amount',
      sort: true,
      searchable: true,
      style: {
        textAlign: 'right',
        borderLeft: '1px solid #dee2e6',
        borderRight: '1px solid #dee2e6'
      },
      headerStyle: {
        textAlign: 'right',
        borderLeft: '1px solid #dee2e6',
        borderRight: '1px solid #dee2e6',
        verticalAlign: 'middle'
      },
      formatter: (cell) => Number(cell).toFixed(2)
    }];

    const defaultSorted = [{
      dataField: 'Name',
      order: 'asc'
    }];

    const pageOptions = {
      sizePerPage: 10,
      totalSize: this.state.gridData,
      custom: true,
    }
    const selectRow = {
      mode: 'checkbox'
    }
    const { SearchBar } = Search;

    const tableStyle = {
      borderCollapse: 'collapse',
      borderSpacing: 0,
      width: '100%'
    };

    return (
      <div className="page-content">
        <Row className="mb-3">
          <Col md={3}>
            <FormGroup>
              <Label>From Date</Label>
              <DatePicker
                selected={this.state.fromDate}
                onChange={this.handleFromDateChange}
                className="form-control"
                dateFormat="dd/MM/yyyy"
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label>To Date</Label>
              <DatePicker
                selected={this.state.toDate}
                onChange={this.handleToDateChange}
                className="form-control"
                dateFormat="dd/MM/yyyy"
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label>&nbsp;</Label>
              <Button 
                color="primary" 
                className="w-100" 
                onClick={this.handleSubmit}
              >
                Submit
              </Button>
            </FormGroup>
          </Col>
        </Row>
        <PaginationProvider
          pagination={paginationFactory(pageOptions)}
          keyField='id'
          columns={columns}
          data={this.state.gridData}
        >
          {({ paginationProps, paginationTableProps }) => (
            <ToolkitProvider
              keyField='id'
              columns={columns}
              data={this.state.gridData}
              search
              bootstrap4
            >
              {toolkitProps => (
                <React.Fragment>
                  <Row className="mb-2">
                    <Col md="4">
                      <div className="search-box me-2 mb-2 d-inline-block">
                        <div className="position-relative">
                          <SearchBar
                            {...toolkitProps.searchProps}
                          />
                          <i className="bx bx-search-alt search-icon" />
                        </div>
                      </div>
                    </Col>
                    <Col md="4">
                      <div className="search-box me-2 mb-2 d-inline-block">
                        <div className="position-relative">
                          {this.state.gridData && this.state.gridData.length > 0 && (
                            <>
                              <Button 
                                color="success" 
                                className="btn-rounded waves-effect waves-light mb-2 mr-2"
                                onClick={this.exportToExcel}
                              >
                                <i className="mdi mdi-file-excel mr-1"></i> Export to Excel
                              </Button>
                              <Button 
                                color="info" 
                                className="btn-rounded waves-effect waves-light mb-2 mr-2"
                                onClick={this.printReport}
                              >
                                <i className="mdi mdi-printer mr-1"></i> Print Report
                              </Button>
                            </>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xl="12">
                      <div className="table-responsive">
                        <BootstrapTable
                          keyField={"id"}
                          responsive
                          bordered={true}
                          striped={false}
                          defaultSorted={defaultSorted}
                          selectRow={selectRow}
                          classes={
                            "table align-middle table-nowrap table-bordered"
                          }
                          headerWrapperClasses={"thead-light"}
                          style={tableStyle}
                          {...toolkitProps.baseProps}
                          {...paginationTableProps}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row className="align-items-md-center mt-30">
                    <Col className="inner-custom-pagination d-flex">
                      <div className="d-inline">
                        <SizePerPageDropdownStandalone
                          {...paginationProps}
                        />
                      </div>
                      <div className="text-md-right ms-auto">
                        <PaginationListStandalone
                          {...paginationProps}
                        />
                      </div>
                    </Col>
                  </Row>
                </React.Fragment>
              )}
            </ToolkitProvider>
          )}
        </PaginationProvider>
      </div>
    );
  }
}
export default compose(container)(GstReport);